<template>
    <div class="group-row">
        <tr-text class="column" v-bind="props.label" :tracker="tracker"
                @edit-tr="$emit('edit-tr', $event)"></tr-text>
        <div class="widget-container">
            <component :is="child.tag" v-for="(child, idx) in children" :key="idx"
                v-bind="child"
                :index="idx"
                :tracker="tracker"
                :showLabel="true"
                @edit-tr="$emit('edit-tr', $event)"
            ></component>
        </div>
    </div>
</template>

<script>
import TrText               from "@/components/translation/TrText"
import I18nText             from "@/components/i18n/I18nText"
import I18nEditbox          from "@/components/i18n/I18nEditbox"
import I18nCheckbox         from "@/components/i18n/I18nCheckbox"
import I18nCombobox         from "@/components/i18n/I18nCombobox"
import I18nGetsum           from "@/components/i18n/I18nGetsum"

export default {
    name: "I18nGroupRow",
    components: {TrText, I18nText, I18nEditbox, I18nCheckbox, I18nCombobox, I18nGetsum},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    }
}
</script>

<style>
    .group-row {
        position: relative;
        display: flex;
    }
    .widget-container {
        display: flex;
    }

</style>